import {
    Component,
    ElementRef,
    Input
} from '@angular/core';

@Component({
    selector: 'pm-layout-10',
    templateUrl: './layout-10.html'  
})
export class Layout10Component {
   
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-10-component.ts